import { useEffect } from 'react'
import { Modal, Form, Input, Message } from '@arco-design/web-react'
import { adminResetUserPasswordApi, type AdminUser } from '@/api/user'
import { getFormValidateErrorMessage } from '@/utils/helpers'

interface Props {
  visible: boolean
  user: AdminUser | null
  onCancel: () => void
  onSuccess?: () => void
}

export default function ResetPasswordModal({ visible, user, onCancel, onSuccess }: Props) {
  const [form] = Form.useForm()

  useEffect(() => {
    if (visible) form.resetFields()
  }, [visible, form])

  const submit = async () => {
    try {
      const { password, confirm } = await form.validate()
      if (password !== confirm) {
        Message.error('两次输入的密码不一致')
        return
      }
      if (!user) return
      await adminResetUserPasswordApi(user.id, password)
      Message.success('已重置密码')
      onSuccess?.()
      onCancel()
    } catch (err: unknown) {
      Message.error(getFormValidateErrorMessage(err))
    }
  }

  return (
    <Modal
      title={user ? `重置密码 · ${user.username}` : '重置密码'}
      visible={visible}
      onCancel={onCancel}
      onOk={submit}
      style={{ width: 480 }}
    >
      <Form form={form} layout="vertical">
        <Form.Item field="password" label="新密码" rules={[{ required: true, minLength: 6, message: '至少 6 位' }]}>
          <Input.Password placeholder="至少 6 位" />
        </Form.Item>
        <Form.Item field="confirm" label="确认密码" rules={[{ required: true }]}>
          <Input.Password placeholder="再次输入新密码" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
